import React from "react"
import CookieConsent from "react-cookie-consent"
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies"
import { useLocation } from "@reach/router"
import { useTranslation } from "react-i18next"

const CookieBanner = () => {
  const location = useLocation()
  const { t } = useTranslation()

  return (
    <CookieConsent
      location="bottom"
      enableDeclineButton
      buttonText={t("cookiebanner.accept")}
      declineButtonText={t("cookiebanner.decline")}
      onAccept={() => {
        initializeAndTrack(location)
      }}
      cookieName="gatsby-gdpr-google-analytics"
      style={{
        padding: "15px",
        left: "auto",
        right: 0,
        color: "currentColor",
        width: "100%",
        background: "#fff",
        borderTop: "1px solid #fff",
        boxShadow: "0 0 25px rgba(0,0,0,.1)",
        justifyContent: "space-between",
      }}
      contentStyle={{ display: "block", flex: "auto", margin: "0 0 15px" }}
      declineButtonStyle={{
        fontWeight: 700,
        background: "#eee",
        color: "#000",
        textTransform: "uppercase",
        fontSize: "13px",
        margin: 0,
      }}
      buttonStyle={{
        fontWeight: 700,
        background: "var(--primary)",
        color: "#fff",
        textTransform: "uppercase",
        fontSize: "13px",
        margin: "0 0 0 15px",
      }}
      expires={150}
    >
      {t("cookiebanner.consent")}
    </CookieConsent>
  )
}

export { CookieBanner }
